import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          query {\n            me {\n              createdAt\n              dealer {\n                id\n                ifStoreOpening\n                status\n              }\n              email\n              id\n              phone\n              role\n              updatedAt\n              username\n            }\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __decorate } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import gql from 'graphql-tag';
import { State } from 'vuex-class';
import AppSnack from '@/components/AppSnack.vue';
import AppDrawer from '@/components/AppDrawer.vue';
import AppNav from '@/components/AppNav.vue';
import { dispatchSignIn } from '@/store/dispatches';
import { AuditStatus } from '@/interfaces/status';
import { showNotification } from '@/utils/snack';
import { SnackType } from '@/interfaces/snack';

var App = /*#__PURE__*/function (_Vue) {
  _inherits(App, _Vue);

  var _super = _createSuper(App);

  function App() {
    var _this;

    _classCallCheck(this, App);

    _this = _super.apply(this, arguments);
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.hideNav = true;
    _this.ready = false;
    _this.ifMenu = false;
    return _this;
  }

  _createClass(App, [{
    key: "onRouteChanged",
    value: function onRouteChanged(to) {
      if (to.name === 'SignIn' || !to.name) {
        this.ifMenu = false;
        this.hideNav = true;
      } else {
        this.ifMenu = true;
        this.hideNav = false;
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var token = localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_KEY);
      this.onResize();

      if (token) {
        this.getMe();
      } else {
        this.$router.replace({
          name: 'SignIn'
        });
        this.ready = true;
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
    }
  }, {
    key: "getMe",
    value: function () {
      var _getMe = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result, me, _me$dealer;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$apollo.query({
                  query: gql(_templateObject())
                });

              case 3:
                result = _context.sent;

                if (!result.errors) {
                  _context.next = 9;
                  break;
                }

                localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE_KEY);

                if (this.$route.name !== 'SignIn') {
                  this.$router.replace({
                    name: 'SignIn'
                  });
                }

                _context.next = 18;
                break;

              case 9:
                me = result.data.me;

                if (!(me.role === 'DEALER')) {
                  _context.next = 15;
                  break;
                }

                if (!(((_me$dealer = me.dealer) === null || _me$dealer === void 0 ? void 0 : _me$dealer.status) !== AuditStatus.APPROVED)) {
                  _context.next = 15;
                  break;
                }

                showNotification({
                  msg: '审核未通过',
                  type: SnackType.Error
                });
                this.$router.replace({
                  name: 'SignIn'
                });
                return _context.abrupt("return", false);

              case 15:
                dispatchSignIn(result.data.me);
                sessionStorage.setItem('role', result.data.me.role);
                this.ready = true;

              case 18:
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](0);
                localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE_KEY);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 20]]);
      }));

      function getMe() {
        return _getMe.apply(this, arguments);
      }

      return getMe;
    }()
  }]);

  return App;
}(Vue);

__decorate([State(function (state) {
  return state.user.me;
})], App.prototype, "me", void 0);

__decorate([Watch('$route', {
  immediate: true
})], App.prototype, "onRouteChanged", null);

App = __decorate([Component({
  components: {
    AppSnack: AppSnack,
    AppDrawer: AppDrawer,
    AppNav: AppNav
  }
})], App);
export default App;